(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('PermissionGroupFranchiserListController', PermissionGroupFranchiserListController)

    /** @ngInject */
    function PermissionGroupFranchiserListController(UtilHelper, PermissionGroupService, LoadingHelper, sweetAlert) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if (vm.selectedSearchField && vm.searchText)
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getPermissionGroups(start, number, tableState);
        }

        vm.openMigrationModal = () => {
            vm.permissionGroupOrigin = null;
            vm.permissionGroupDestination = null;

            $('#permission-group-migration').appendTo('body').modal('show');

            LoadingHelper.startLoading('.modal-loader');

            PermissionGroupService
                .getAll()
                .then(success => {
                    vm.migrationPermissionGroups = success.Registers;
                    LoadingHelper.stopLoading('.modal-loader');
                }, error => {
                    vm.migrationPermissionGroups = null;

                    UtilHelper.errorCallback(error);
                    LoadingHelper.stopLoading('.modal-loader');
                })
        }

        vm.closeMigrationModal = () => {
            $('#permission-group-migration').modal('hide');
        }

        vm.migrateRegisters = () => {
            sweetAlert.swal({
                title: 'Você tem certeza?',
                text: 'Todos os registros serão migrados para o novo grupo de permissão. Não é possível desfazer essa ação!',
                type: 'warning',
                confirmButtonText: 'Sim, tenho certeza',
                showCancelButton: true,
                cancelButtonText: 'Não, cancelar',
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(response => {
                if (response.value) {
                    LoadingHelper.startLoading('.modal-loader');

                    PermissionGroupService
                        .migrateData(vm.permissionGroupOrigin.Id, vm.permissionGroupDestination.Id)
                        .then(() => {
                            vm.closeMigrationModal();

                            UtilHelper.successCallback('migrate');
                            LoadingHelper.stopLoading('.modal-loader');
                        }, error => {
                            UtilHelper.errorCallback(error);
                            LoadingHelper.stopLoading('.modal-loader');
                        })
                }
            })
        }

        init();

        function getPermissionGroups(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            PermissionGroupService
                .getByParameters(parameters)
                .then(success => {
                    vm.permissionGroups = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.permissionGroups = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Id',
                OrderDescending: false
            }

            if (vm.selectedSearchField && vm.searchText)
                isTableSearch = true;

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;
            vm.searchStatus = 1;

            vm.searchFields = [{
                Value: 'Name',
                Description: 'Descrição'
            }];
        }
    }
}());